/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InvoiceDocument } from '../../models/invoice-document';

export interface SyncInvoiceDocument$Params {
  uuid: string;
}

export function syncInvoiceDocument(http: HttpClient, rootUrl: string, params: SyncInvoiceDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<InvoiceDocument>> {
  const rb = new RequestBuilder(rootUrl, syncInvoiceDocument.PATH, 'post');
  if (params) {
    rb.path('uuid', params.uuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InvoiceDocument>;
    })
  );
}

syncInvoiceDocument.PATH = '/invoice-document/{uuid}/sync';
